import React, { Component } from 'react'
import BigBox from '../../components/ad_types/BigBox'
import SidebarHeadlines from './../../components/headlines/sidebar/SidebarHeadlines'
import zonePosts from './../../components/zone_posts/zonePosts'

class Sidebar extends Component {
    render() {
        const { league, sport, acceptedLeagues } = this.props

        const headlineUrl = acceptedLeagues.hasOwnProperty(league) ? league : sport
        const headlineName = acceptedLeagues.hasOwnProperty(league)
            ? acceptedLeagues[league][0]
            : sport.toUpperCase()

        const Headlines = zonePosts(headlineUrl, 'headlines')(SidebarHeadlines)

        return (
            <div>
                <BigBox bg={false} view="all" visible={true} refresh={false} />
                <Headlines postHeader={headlineName} />
            </div>
        )
    }
}

export default Sidebar
